import {
    formatDateNoTime,
    formatYDM,
    getToken,
    getToken2,
    getUser,
    numberFormatInt
} from "../../Utils/Common";
import Moment from "moment";
import { getAPICall, postAPICall } from "../axiosMethodCalls";

export const getExpenses = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "expenses/get_expense",
            {
                requester: getUser(),
                token: getToken(),
                expense_id: data.id,
                item_name: data.item_name,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getAllExpenses = async () => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "expenses/get_all_expense",
            {
                requester: getUser(),
                token: getToken(),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};


export const updateExpenseStatus = async (id, status) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "expenses/change_status",
            {
                requester: getUser(),
                token: getToken(),
                expense_id: id,
                // amount: amount,
                status: status,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const searchExpenses = async (data) => {
    const date = new Date();
    date.setDate(date.getDate() - 7);

    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    

    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "expenses/search",
            {
                requester: getUser(),
                token: getToken(),
                branch_id: data.branch_id,
                by_branch: data.by_branch,
                status: data.status,
                branch_name: data.branch_name,
                expense_date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : Moment(date).format("YYYY-MM-DD"),
                expense_date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : Moment(nextDay).format("YYYY-MM-DD"),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// FOR DSR EXPENSES
export const searchExpensesByDate = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "expenses/search",
            {
                requester: getUser(),
                token: getToken(),
                status: "approved",
                branch_id: data.branch_id,
                by_branch: data.by_branch,
                branch_name: data.branch_name,
                expense_date_from: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
                expense_date_to: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteExpenses = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "expenses/delete",
            {
                requester: getUser(),
                token: getToken(),
                expense_id: id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// CREATE EXPENSE API
export const createExpense = async (data) => {
    let formData = new FormData();
    data.attachments.map((file) => {
        formData.append(`attachments[]`, file, file.name);
    })
    formData.append('requester', getUser());
    formData.append('token', getToken());
    formData.append('branch_id', data.branch_id ? data.branch_id : "");
    formData.append('expense_date', data.expense_date ? data.expense_date : "");
    formData.append('supplier_name', data.supplier_name ? data.supplier_name : "");
    formData.append('supplier_id', data.supplier_id ? data.supplier_id : "");
    formData.append('remarks', data.remarks ? data.remarks : "");
    formData.append('description', data.description ? data.description : "");
    formData.append('invoice_no', data.invoice_no ? data.invoice_no : "");
    formData.append('encoded_by', data.encoded_by ? data.encoded_by : "");

    data.items.map((item) => {
        formData.append(`names[]`, item.name ? item.name : "");
        formData.append(`units[]`, item.unit ? item.unit : "");
        formData.append(`prices[]`, item.price ? item.price : "");
        formData.append(`quantities[]`, item.qty ? item.qty : "");
    })

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "expenses/create", formData
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// CREATE EXPENSE API
export const updateExpense = async (data) => {
    let formData = new FormData();
    data.attachments.map((file) => {
        formData.append('attachments[]', file, file.name);
        formData.append('attachment_ids[]', null);
    });
    data.prev_files.map((file) => {
        formData.append('attachment_ids[]', file.id);
    });
    formData.append('requester', getUser());
    formData.append('token', getToken());
    formData.append('expense_id', data.id ? data.id : "");
    formData.append('branch_id', data.branch_id ? data.branch_id : "");
    formData.append('expense_date', data.expense_date ? data.expense_date : "");
    formData.append('supplier_name', data.supplier_name ? data.supplier_name : "");
    formData.append('supplier_id', data.supplier_id ? data.supplier_id : "");
    formData.append('remarks', data.remarks ? data.remarks : "");
    formData.append('description', data.description ? data.description : "");
    formData.append('invoice_no', data.invoice_no ? data.invoice_no : "");
    formData.append('encoded_by', data.encoded_by ? data.encoded_by : "");

    data.items.map((item) => {
        formData.append(`names[]`, item.name ? item.name : "");
        formData.append(`units[]`, item.unit ? item.unit : "");
        formData.append(`prices[]`, item.price ? item.price : "");
        formData.append(`quantities[]`, item.qty ? item.qty : "");
    })

    try {
        const response = await postAPICall(
            process.env.REACT_APP_LINK + "expenses/update", formData
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

// -------------POTATO-------------------

export const searchExpensesPotato = async (data) => {
    const date = new Date();
    date.setDate(date.getDate() - 7);

    const nextDay = new Date();
    nextDay.setDate(nextDay.getDate() + 1);
    

    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "expenses/search",
            {
                requester: getUser(),
                token: getToken2(),
                branch_id: data.branch_id,
                by_branch: data.by_branch,
                status: data.status,
                branch_name: data.branch_name,
                expense_date_from: data.date_from ? Moment(data.date_from).format("YYYY-MM-DD") : Moment(date).format("YYYY-MM-DD"),
                expense_date_to: data.date_to ? Moment(data.date_to).format("YYYY-MM-DD") : Moment(nextDay).format("YYYY-MM-DD"),
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const getExpensesPotato = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "expenses/get_expense",
            {
                requester: getUser(),
                token: getToken2(),
                expense_id: data.id,
                item_name: data.item_name,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const deleteExpensesPotato = async (id) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "expenses/delete",
            {
                requester: getUser(),
                token: getToken2(),
                expense_id: id,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const searchExpensesByDatePotato = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "expenses/search",
            {
                requester: getUser(),
                token: getToken2(),
                status: "approved",
                branch_id: data.branch_id,
                by_branch: data.by_branch,
                branch_name: data.branch_name,
                expense_date_from: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
                expense_date_to: data.date ? Moment(data.date).format("YYYY-MM-DD") : Moment().format("YYYY-MM-DD"),
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};

export const updateExpenseStatusPotato = async (id, status) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_POTATO + "expenses/change_status",
            {
                requester: getUser(),
                token: getToken2(),
                expense_id: id,
                // amount: amount,
                status: status,
            }, "potato"
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};